import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

const Routes = ({
	tabs,
	path,
	url,
	isMaterialTabVisible,
	isEncodingTabVisible,
	isPaymentsTabVisible,
	isTrackingTabVisible
}) => {
	const isCreate = url.includes('create');

	const renderRoute = () =>
		tabs.map(
			({ path: slug, name, disableOnCreate, component, isDisabled }, index) => {
				if (!isMaterialTabVisible && path === 'materials') {
					return null;
				} else if (!isEncodingTabVisible && path === 'encoding') {
					return null;
				} else if (!isPaymentsTabVisible && path === 'payments') {
					return null;
				} else if (!isTrackingTabVisible && path === 'tracking') {
					return null;
				} else if (isDisabled) {
					return null;
				} else {
					return (
						(!isCreate || !disableOnCreate) && (
							<Route
								key={`${name}-${index}`}
								path={`${path}/${slug}`}
								render={() => component}
							/>
						)
					);
				}
			}
		);
	return <Switch>{renderRoute()}</Switch>;
};

Routes.propTypes = {
	tabs: PropTypes.array.isRequired,
	path: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired,
	isMaterialTabVisible: PropTypes.bool.isRequired
};

export default Routes;
